<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 7: Certification Statement
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field :rules="{required: { allowFalse: false }}" name="Agreement">
        <div>
          <d-checkbox v-model="firmAttests">
            Our firm attests that we are licensed by QCP to certify work in our contract scope which is
            subject to QCP certification, and that the work we provide will conform to project specifications.
            We understand that the AWI Standard designated by contract documents will apply where specification
            detail for a particular item is absent.
          </d-checkbox>
        </div>
      </d-field>
      <d-field label="Signature">
        <d-input v-model="signature" aria-label="Full name signature" required placeholder="Your Full Name" />
      </d-field>
      <d-field label="Title">
        <d-input v-model="title" aria-label="title" required placeholder="Title, Position, or Role" />
      </d-field>
      <d-field label="Email">
        <d-input v-model="email" aria-label="email" required type="email" />
      </d-field>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CERTIFICATION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('projectCertificationForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['firmAttests', 'signature', 'title', 'email'],
        module: 'projectCertificationForm',
        base: 'formFields',
        mutation: PROJECT_CERTIFICATION_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>